module.exports = __webpack_public_path__ + "static/media/icon_166.1cf69b02.svg";